import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { API_STATUS } from "../../constants";
import { UploadSubMedia } from "../../apis/user/upload_sub_media";

export default function AddArtistPhotos({ subId, setReload, setAddMedia }) {
    const navigate = useNavigate();
    const [selFiles, setFiles] = useState([]);
    const [photos, setPhotos] = useState([]);
    const [videos, setVideos] = useState([]);
    const [UploadApi, setUploadApi] = useState(API_STATUS);
    const [progress, setProgress] = useState(0);
    const [balspace, setBalspace] = useState('Unlimited');

    useEffect(() => {
        if (selFiles.length > 0) {
            Array.from(selFiles).map(async (file) => {
                let file_url = URL.createObjectURL(file);
                if (file.type === 'video/mp4') {
                    setVideos(videos => [...videos, file_url]);
                } else {
                    setPhotos(photos => [...photos, file_url]);
                }
            });
        }
    }, [selFiles]);

    const uploadMedia = () => {
        let formData = new FormData();
        Array.from(selFiles).map(async (file) => {
            formData.append('photo', file);
        });
        formData.append('subId', subId);
        const token = sessionStorage.getItem('LOGIN_TOKEN');
        formData.append('code', token);

        UploadSubMedia(formData, setUploadApi);
    }

    useEffect(() => {
        console.log(UploadApi);
        if (UploadApi.isLoader) {
            setProgress(UploadApi.process);
        }
        if (!UploadApi.isLoader && !UploadApi.isError && UploadApi.data != null) {
            setAddMedia(false);
            setReload(true);
        }

    }, [UploadApi])

    useEffect(() => {
        const login_data = sessionStorage.getItem('LOGIN_DATA');
        const udata = JSON.parse(login_data);
        if (udata['space_bal'] != 'Unlimited') {
            setBalspace(parseInt(udata['space_bal']));
        } else {
            setBalspace('Unlimited');
        }
    }, [])


    return <>
        <div className="mt-6 mb-20 text-sm font-medium text-gray-600 dark:text-white/80">
            {
                balspace != 'Unlimited' && balspace < 10 &&

                <div className="bg-white shadow-xl rounded-xl p-4" style={{ maxWidth: 400 }}>
                    <div className="text-base text-red-600">Insufficient Storage</div>
                    <div className="text-base">Purchase additional space to continue posting more photos/videos</div>
                    <button onClick={() => {
                        navigate('/storage');
                    }} className="button bg-pink-100 text-pink-600 border border-pink-200 mt-3">Manage Storage</button>
                </div>
            }
            {
                (balspace == 'Unlimited' || balspace > 10) &&
                <div className="uk-switcher bg-white border rounded-xl shadow-sm md:py-12 md:px-20 p-6 overflow-hidden dark:border-slate-700 dark:bg-dark2">
                    <div className="uk-active" style={{ position: 'relative' }}>
                        {
                            photos.length > 0 &&

                            <div className="grid lg:grid-cols-3 sm:grid-cols-3 grid-cols-2 gap-3 mt-20 uk-slider-items" uk-scrollspy="target: > div; cls: uk-animation-scale-up; delay: 100">
                                {
                                    photos.map((img, k) =>
                                        <div key={k} className="-ml-2 uk-scrollspy-inview mb-6" uk-scrollspy="target: > li; cls: uk-animation-slide-right-small; delay: 50" uk-lightbox="">
                                            <a href={img} data-caption=" I love beauty and emotion">
                                                <div className=" lg:hover:scale-105 hover:shadow-lg hover:z-10 duration-500 delay-100">
                                                    <div className="w-full lg:h-64 aspect-[2.5/4] realtive">
                                                        <img src={img} className="rounded-lg w-full h-full object-cover inset-0" alt="" />
                                                    </div>
                                                </div>
                                            </a>
                                        </div>
                                    )
                                }
                            </div>
                        }

                        {
                            videos.length > 0 &&
                            <div className="grid lg:grid-cols-3 sm:grid-cols-3 grid-cols-2 gap-3 mt-20 uk-slider-items" uk-scrollspy="target: > div; cls: uk-animation-scale-up; delay: 100">
                                {
                                    videos.map((img, k) =>
                                        <div key={k} className="-ml-2 uk-scrollspy-inview mb-6" uk-scrollspy="target: > li; cls: uk-animation-slide-right-small; delay: 50" uk-lightbox="">
                                            <a href={img} data-caption=" I love beauty and emotion">
                                                <div className=" lg:hover:scale-105 hover:shadow-lg hover:z-10 duration-500 delay-100">
                                                    <div className="w-full lg:h-64 aspect-[2.5/4] realtive">
                                                        <video class="h-full w-full rounded-lg" controls>
                                                            <source
                                                                src={img}
                                                                type="video/mp4"
                                                            />
                                                            Your browser does not support the video tag.
                                                        </video>
                                                    </div>
                                                </div>
                                            </a>
                                        </div>
                                    )
                                }
                            </div>
                        }

                        <div className="space-y-4 flex flex-col justify-center" uk-scrollspy="target: > div; cls: uk-animation-scale-up; delay: 300;repeat:true">
                            <label for="addPhoto" className="hover: cursor-pointer">
                                <input onChange={(e) => {
                                    setFiles(e.target.files);
                                }} id="addPhoto" type="file" name="photo[]" multiple className="hidden" />
                                <div uk-scrollspy-className="uk-animation-scale-up" className="uk-scrollspy-inview">
                                    <svg className="mx-auto text-gray-600 dark:text-white" width="96" height="77" role="img" viewBox="0 0 97.6 77.3"><path d="M16.3 24h.3c2.8-.2 4.9-2.6 4.8-5.4-.2-2.8-2.6-4.9-5.4-4.8s-4.9 2.6-4.8 5.4c.1 2.7 2.4 4.8 5.1 4.8zm-2.4-7.2c.5-.6 1.3-1 2.1-1h.2c1.7 0 3.1 1.4 3.1 3.1 0 1.7-1.4 3.1-3.1 3.1-1.7 0-3.1-1.4-3.1-3.1 0-.8.3-1.5.8-2.1z" fill="currentColor"></path><path d="M84.7 18.4 58 16.9l-.2-3c-.3-5.7-5.2-10.1-11-9.8L12.9 6c-5.7.3-10.1 5.3-9.8 11L5 51v.8c.7 5.2 5.1 9.1 10.3 9.1h.6l21.7-1.2v.6c-.3 5.7 4 10.7 9.8 11l34 2h.6c5.5 0 10.1-4.3 10.4-9.8l2-34c.4-5.8-4-10.7-9.7-11.1zM7.2 10.8C8.7 9.1 10.8 8.1 13 8l34-1.9c4.6-.3 8.6 3.3 8.9 7.9l.2 2.8-5.3-.3c-5.7-.3-10.7 4-11 9.8l-.6 9.5-9.5 10.7c-.2.3-.6.4-1 .5-.4 0-.7-.1-1-.4l-7.8-7c-1.4-1.3-3.5-1.1-4.8.3L7 49 5.2 17c-.2-2.3.6-4.5 2-6.2zm8.7 48c-4.3.2-8.1-2.8-8.8-7.1l9.4-10.5c.2-.3.6-.4 1-.5.4 0 .7.1 1 .4l7.8 7c.7.6 1.6.9 2.5.9.9 0 1.7-.5 2.3-1.1l7.8-8.8-1.1 18.6-21.9 1.1zm76.5-29.5-2 34c-.3 4.6-4.3 8.2-8.9 7.9l-34-2c-4.6-.3-8.2-4.3-7.9-8.9l2-34c.3-4.4 3.9-7.9 8.4-7.9h.5l34 2c4.7.3 8.2 4.3 7.9 8.9z" fill="currentColor"></path><path d="M78.2 41.6 61.3 30.5c-2.1-1.4-4.9-.8-6.2 1.3-.4.7-.7 1.4-.7 2.2l-1.2 20.1c-.1 2.5 1.7 4.6 4.2 4.8h.3c.7 0 1.4-.2 2-.5l18-9c2.2-1.1 3.1-3.8 2-6-.4-.7-.9-1.3-1.5-1.8zm-1.4 6-18 9c-.4.2-.8.3-1.3.3-.4 0-.9-.2-1.2-.4-.7-.5-1.2-1.3-1.1-2.2l1.2-20.1c.1-.9.6-1.7 1.4-2.1.8-.4 1.7-.3 2.5.1L77 43.3c1.2.8 1.5 2.3.7 3.4-.2.4-.5.7-.9.9z" fill="currentColor"></path></svg>
                                </div>
                                <div className="mx-auto uk-scrollspy-inview text-center mt-2">
                                    <span className="text-white bg-blue-600 rounded-lg py-1.5 px-4 text-sm dark:bg-white/5"> Select Photos/Videos</span>
                                </div>
                            </label>

                        </div>
                        {
                            selFiles.length > 0 &&
                            <div className="flex items-center justify-center gap-4 mt-10 mb-10">
                                <button
                                    onClick={uploadMedia}
                                    type="button" className="button lg:px-10 bg-primary text-white max-md:flex-1"> Upload <span className="ripple-overlay"></span></button>
                            </div>
                        }

                        {
                            UploadApi.isLoader &&
                            <div role="status" style={{ position: 'absolute', top: 0, right: 0, bottom: 0, left: 0, backgroundColor: '#ffffffb8', justifyItems: 'center', alignContent: 'center' }}>

                                {
                                    progress < 100 &&
                                    <div class="w-full bg-gray-200 rounded-full h-2.5 dark:bg-gray-700">
                                        <div class="bg-blue-600 text-xs  h-2.5 text-blue-100 text-center p-0.5 leading-none rounded-full" style={{ width: progress + '%' }}> {progress}</div>
                                    </div>
                                }

                                {
                                    progress === 100 &&
                                    <>
                                        <svg aria-hidden="true" class="w-8 h-8 text-gray-200 animate-spin dark:text-gray-600 fill-blue-600" viewBox="0 0 100 101" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z" fill="currentColor" /><path d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z" fill="currentFill" /></svg>
                                        <span class="sr-only">Loading...</span>
                                    </>
                                }
                            </div>
                        }
                    </div>
                </div>
            }
        </div >
    </>
}